var map = {
	"./add-circle.svg": "793f",
	"./add.svg": "162c",
	"./alert-error.svg": "5354",
	"./alert-info.svg": "e254",
	"./alert-success.svg": "1114",
	"./alert-warning.svg": "6b7e",
	"./align-center.svg": "aa2e",
	"./align-left.svg": "47a0",
	"./align-right.svg": "7b6b",
	"./bookmark.svg": "a9d1",
	"./chevron-down.svg": "b265",
	"./chevron-left.svg": "da02",
	"./chevron-right.svg": "fef1",
	"./chevron-up.svg": "54fb",
	"./close-circle.svg": "c2be",
	"./close.svg": "1151",
	"./company.svg": "5ec1",
	"./contact.svg": "b5b6",
	"./default-avatar-company.svg": "8f9d",
	"./default-avatar-user.svg": "cb8b",
	"./edit.svg": "ed14",
	"./ellipsis.svg": "fdb1",
	"./email.svg": "39da",
	"./file.svg": "6b71",
	"./filter-icon.svg": "5f00",
	"./follow.svg": "16fe",
	"./guest-comments.svg": "2f8b",
	"./h5-solid.svg": "0bf0",
	"./hamburger-menu.svg": "f4fa",
	"./handle.svg": "4e712",
	"./heart.svg": "36d2",
	"./home.svg": "4773",
	"./image-large.svg": "12fe",
	"./image-medium.svg": "1099",
	"./image-small.svg": "9fde",
	"./kebab.svg": "95402",
	"./lead.svg": "8eec",
	"./list-view.svg": "0fad",
	"./milestone.svg": "3318",
	"./note.svg": "7031",
	"./notification-bell.svg": "b25a",
	"./opportunity.svg": "d2e6",
	"./phone.svg": "7980",
	"./placeholder-text.svg": "836c",
	"./presence-editor-mode.svg": "08a6",
	"./presence-reader-mode.svg": "765f",
	"./product-switcher.svg": "ef16",
	"./product.svg": "e5b1",
	"./quote-left.svg": "517a",
	"./reduce-width.svg": "252f",
	"./sad-face.svg": "5fc4",
	"./search.svg": "22b5",
	"./stage-arrow.svg": "8152",
	"./status-chip.svg": "00ea",
	"./task.svg": "ae18",
	"./tick.svg": "1e83",
	"./undo.svg": "3ff2",
	"./user.svg": "c00c",
	"./wrap-left.svg": "30b9",
	"./wrap-right.svg": "f4f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f39";